export default __webpack_public_path__ + "static/media/redcross.da02b1b8.svg";